


















































import Vue from 'vue'

export default Vue.extend({
  // computed: {
  //   activeTab: {
  //     get (): string {
  //       return this.$route.name!
  //     },
  //     set () {

  //     }
  //   }
  // },
  data() {
    return {
      activeTab: this.$route.name || 'pollsReadyList'
    }
  },
  watch: {
    $route (to, from) {
      const routeName = this.$route.name;

      if (routeName === 'pollsReadyListPage') {
        this.activeTab = 'pollsReadyList'
      } else if (routeName === 'pollsInProgressListPage') {
        this.activeTab = 'pollsInProgressList'
      } else if (routeName === 'pollsComplitedListPage') {
        this.activeTab = 'pollsComplitedList'
      } else if (routeName === 'pollsCanceledListPage') {
        this.activeTab = 'pollsCanceledList'
      }
    }
  },
  async beforeRouteEnter (to, from, next) {
    try {
      next()
    } catch (error) {
      next('notFound')
    }
  }
})
